function Header() {
    return (
        <div>
            <h2 style={{ fontWeight: "bold", backgroundColor: "black", color: "white", padding: "1.5rem" }}>React Movie App</h2>
        </div>
    )
}
export default Header;